function openItemTab(evt, tabID, index) {
         
    const tabcontent = document.querySelectorAll(`#${tabID}-container .tabs-list__content`);
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].classList.remove('active');
    }

    
    const tablinks = document.querySelectorAll(`#${tabID}-container .tabs-tab__item`);
    for (let i = 0; i < tablinks.length; i++) {
        tablinks[i].classList.remove('active');
    }
    console.log(tabID, index, evt, tablinks)
    
    setTimeout(()=>{
        document.getElementById(`${tabID}-${index}`).classList.add('active');
        document.getElementById(`${tabID}-${index}-content`).classList.add('active');
    }, 100)
  }